import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import { fonts } from '../../base/typography';

const allowBorder = (style: string, side: string): boolean => {
    if (style === 'all') return true;
    if (style === 'columns' && (side === 'left' || side === 'right')) {
        return true;
    }
    if (style === 'rows' && (side === 'top' || side === 'bottom')) {
        return true;
    }
    return false;
};

const Styles = styled.div`
    .table {
        border-spacing: 0;
        border: ${(props: any) => (props.bordered === true ? '1px solid #eee' : '0')};
        border-bottom: 0;
        ${(props: any) => allowBorder(props.borderStyle, 'left') === false && 'border-left: 0;'};
        ${(props: any) => allowBorder(props.borderStyle, 'right') === false && 'border-right: 0;'};
        font-family: ${fonts.body};
        font-size: 16px;
        width: 100%;
        /* .tr {
            :last-child {
                .td {
                    border-bottom: 0;
                }
            }
        } */
        .th {
            font-weight: bold;
        }
        .th,
        .td {
            border: ${(props: any) => (props.bordered === true ? '1px solid #eee' : '0')};
            border-top: 0;
            border-left: 0;
            ${(props: any) => allowBorder(props.borderStyle, 'right') === false && 'border-right: 0;'};
            ${(props: any) => allowBorder(props.borderStyle, 'bottom') === false && 'border-bottom: 0;'};
            margin: 0;
            padding: 0.5rem;
            text-align: center;
            :last-child {
                border-right: 0;
            }
        }
        thead tr:last-child .th {
            border-bottom: 1px solid #bbb;
        }
        div.thead,
        div.tbody {
            .tr:last-child {
                .th, .td {
                    border-bottom: 0;
                }
            }
        }
    }
    ${(props: any) => props.isBlockLayout
        && `
        .table {
            display: inline-block;
            overflow-x: auto;
        }
    `}
    ${css({
        '.table': {
            borderColor: 'bg.100',
            '.th': {
                backgroundColor: 'bg.300',
                borderColor: 'bg.100',
                fontFamily: 'label',
                fontSize: 'xs',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                letterSpacing: 'widest'
            },
            '.td': {
                borderColor: 'bg.100'
            },
            '.tr:last-child': {
                '.th': {
                    backgroundColor: 'bg.200'
                }
            }
        }
    })}
    ${(props: any) => props.overrides}
`;

export default Styles;
